import { MovimientoDetalle } from './movimiento_detalle';

export class Movimiento{
    
    public constructor(
        public tipo_movimiento_id:String = "",
        public bodega_id:String = "",
        public bodega_id_e:String = "",
        public detalle : Array<MovimientoDetalle> = [],
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public usuario_id:String = null,



        public tipo:String = "",
    ){}

}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/movimiento.ts